import { ScreenWrapper } from '@/components/templates/ScreenWrapper.tsx'
import { Success } from '@/components/templates/Success.tsx'
import { useTrackFormProgress } from '@/hooks/useTrackFormProgress.ts'
import { useAppointmentStore } from '@/store.ts'
import { VelthuisFormStep } from '@/utils/VelthuisFormSteps.ts'

const SuccessScreen = () => {
  const { resetStore, selectedSlot } = useAppointmentStore()

  const { trackFormInteraction } = useTrackFormProgress(
    VelthuisFormStep.AppointmentConfirmed,
    {
      complete: true,
    },
  )

  if (!selectedSlot) {
    return null
  }

  return (
    <ScreenWrapper>
      <Success
        slot={selectedSlot!}
        onClose={() => {
          resetStore()
          trackFormInteraction({
            action: 'previous',
            formFieldName: 'close',
          })
          window.open('https://www.velthuiskliniek.nl/', '_self')
        }}
      />
    </ScreenWrapper>
  )
}

export { SuccessScreen }
